import {Component, EventEmitter, Input, Output} from '@angular/core';

import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [MatCheckbox, FormsModule, MatSelect, MatOption]
})
export class SelectComponent {
    _data: any[] = [];
    myData = { checked: false, type: null, item: null };
    public autreChoix: any;

    @Output() receveEmitted = new EventEmitter();

    get data() {
        return this._data;
    }

    @Input()
    set data(data: any[]) {
        if (data != null && data != undefined && data.length) {
            this._data = data;
            this.myData.type = data[0]['@type'];
        }
    }
    @Input() label?: string = '';
    @Input() autre?: boolean = false;

    checked = false;
    //typeData:any="";
    item: any = null;

    updateMyData() {
        if (this.myData.item != null) {
            setTimeout(() => {
                this.receveEmitted.emit(this.myData);
            }, 100);
        } else {
            //TODO: Gerer le cas d'un nouvel élément
        }
    }

    /***************************************************************************************************************
     * @description Emit to parent
     * @param {any} $event
     * @memberof SelectComponent
     *
     */
    changeChecked($event) {
        setTimeout(() => {
            const data = { checked: this.checked, type: this.data[0]['@type'] };
            this.receveEmitted.emit(data);
        }, 100);
    }
}
